/* eslint-disable no-case-declarations */
import { getAuthUserInfoFromToken } from "../../components/AppBase/AppAuthProvider";
import {
  GET_ORG_TEAMS,
  GET_TEAM_MEMBERS,
  GET_USERS,
  TeamMembersActions,
  SEARCH_ORG_TEAMS,
  GET_MY_TEAMS,
  GET_PROGRESS_OF_TEAM,
  GET_MY_PROGRESS,
  GET_PROGRESS_OF_USERS,
  GET_MY_UNRESPONDED_MESSAGE_COUNT,
  GET_ALL_USERS,
  UPDATE_USER_OPT_IN_ROLES,
  UPDATE_USER_LOCATIONS,
} from "../../types/actions/TeamMembers.actions";
import { TeamMembersState } from "../../types/models/TeamMembersState";

const userInfo = getAuthUserInfoFromToken();

const initialSettings: TeamMembersState = {
  orgProgress: undefined,
  baseOrgTeams: undefined,
  orgTeams: undefined,
  orgTeamSearchText: undefined,
  users: undefined,
  myTeams: undefined,
  teamProgressList: undefined,
  userProgress: undefined,
  myProgress: undefined,
  progressOfUsers: undefined,
  unrespondedMessageCount: undefined,
  allUsers: undefined,
};

const TeamMemberReducer = (state = initialSettings, action: TeamMembersActions) => {
  switch (action.type) {
    case GET_TEAM_MEMBERS:
      return {
        ...state,
        orgProgress: action.payload,
        userProgress: action.payload?.find((prog) => prog.email === userInfo?.Email),
      };
    case GET_ORG_TEAMS:
      return {
        ...state,
        baseOrgTeams: action.payload,
        orgTeams: action.payload,
        orgTeamSearchText: undefined,
      };
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case SEARCH_ORG_TEAMS:
      return {
        ...state,
        orgTeams: action.payload.SearchResults,
        orgTeamSearchText: action.payload.SearchText,
      };
    case GET_MY_TEAMS:
      return {
        ...state,
        myTeams: action.payload,
      };
    case GET_PROGRESS_OF_TEAM:
      return {
        ...state,
        teamProgressList: action.payload,
      };
    case GET_MY_PROGRESS:
      return {
        ...state,
        myProgress: action.payload,
      };
    case GET_PROGRESS_OF_USERS:
      return {
        ...state,
        progressOfUsers: action.payload,
      };
    case GET_MY_UNRESPONDED_MESSAGE_COUNT:
      return {
        ...state,
        unrespondedMessageCount: action.payload,
      };
    case GET_ALL_USERS:
      return {
        ...state,
        allUsers: action.payload,
      };
    case UPDATE_USER_OPT_IN_ROLES:
      return {
        ...state,
        allUsers: state.allUsers?.map((user) =>
          user.Id === action.payload.userId
            ? { ...user, OptInRoleIds: action.payload.optInRoleIds }
            : user
        ),
      };
    case UPDATE_USER_LOCATIONS:
      return {
        ...state,
        allUsers: state.allUsers?.map((user) =>
          user.Id === action.payload.userId
            ? { ...user, LniIds: action.payload.locationIds }
            : user
        ),
      };
    default:
      return state;
  }
};

export default TeamMemberReducer;
